<dx-data-grid
  [height]="'100%'"
  [showColumnHeaders]="false"
  [renderAsync]="true"
  [selectedRowKeys]="rowSelection"
  [keyExpr]="'id'"
  [columns]="columns"
  [dataSource]="filteredExcelModel"
  [autoNavigateToFocusedRow]="true"
  (onRowClick)="onRowClicked($event)"
>
  <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
  <dxo-load-panel [enabled]="true"></dxo-load-panel>
  <dxo-scrolling [mode]="'virtual'"></dxo-scrolling>
  <dxo-row-dragging [onDragStart]="onDragStart" [onAdd]="onDrop" [onReorder]="onReorder" [group]="'dragDropGroup'" dragTemplate="dragTemplate" [allowDropInsideItem]="true" [dropFeedbackMode]="'indicate'"></dxo-row-dragging>
  <dxo-editing mode="cell" [allowUpdating]="!!exportMode" [startEditAction]="'click'"></dxo-editing>
  <!-- template for the dragged item -->
  <div
    *dxTemplate="let dragInfo of 'dragTemplate'"
    class="item dx-card dx-theme-text-color dx-theme-background-color shadow-lg p-3 bg-body rounded dragTemplate"
  >
    <div>
      {{ getDragInfo(dragInfo.itemData) }}
    </div>
  </div>

  <div
    *dxTemplate="let cell of 'importCellTemplate'" class="w-100">
    <div class="d-flex flex-column w-100" [ngClass]="{ inUse: cell.data.pimFields?.length > 0 }">
      <div class="templateExcelHead text-truncate" [title]="cell.data.title">{{ cell.data.title }}</div>
      <div class="templateExcelLine text-truncate" [title]="cell.data.row1">{{ cell.data.row1 }}</div>
      <div class="templateExcelLine text-truncate" [title]="cell.data.row2">{{ cell.data.row2 }}</div>
      <div class="templateExcelLine text-truncate" *ngIf="cell.data.pimFields?.length > 0" [title]="getDragInfo(cell.data)"><i class="dx-icon dx-icon-link align-middle"></i>&nbsp;{{ getDragInfo(cell.data) }}</div>
    </div>
  </div>


  <div
    *dxTemplate="let cell of 'exportCellTemplate'">
    <div class="d-flex flex-column w-100" [ngClass]="{ inUse: cell.data.pimFields?.length > 0 }">
      <div class="templateExcelHead text-truncate" [title]="cell.data.title">{{ cell.data.title }}</div>
      <div class="templateExcelLine text-truncate" *ngIf="cell.data.pimFields?.length > 0" [title]="getDragInfo(cell.data)"><i class="dx-icon dx-icon-link align-middle"></i>&nbsp;{{ getDragInfo(cell.data) }}</div>
      <div class="templateExcelLine text-truncate" *ngIf="!cell.data.pimFields?.length" [title]="cell.data.defaultValue">{{ cell.data.defaultValue }}</div>
    </div>
  </div>

  <div
    *dxTemplate="let cell of 'exportCellEditTemplate'"
    class="templateExcelExportColumn"
    id="templateExcelDiv_{{ cell.data.id }}"
  >
    <div>
      <div class="d-flex flex-row" [ngStyle]="{ gap: '0.5rem' }">
        <div class="d-flex flex-column flex-grow-1">
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}" [ngStyle]="{width: '100%'}">
            <label class="placeLabel {{ cell.data.title?.length > 0 ? 'placeLabelSmall' : '' }}">FIELD_TITLE</label>
            <dx-text-box [(value)]="cell.data.title" placeholder="" (onValueChanged)="update($event)"></dx-text-box>
          </div>
          <div *ngIf="cell.data.pimFields == null || cell.data.pimFields?.length == 0" class="templateExcelContent">
            <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}" [ngStyle]="{width: '100%'}">
              <label class="placeLabel {{ cell.data.defaultValue?.length > 0 ? 'placeLabelSmall' : '' }}">
                FIELD_VALUE
              </label>
              <dx-text-box
                [(value)]="cell.data.defaultValue"
                [showClearButton]="true"
                placeholder=""
                (onValueChanged)="update($event)"
              ></dx-text-box>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</dx-data-grid>
<dx-popover *ngIf="popoverVisible"
  [target]="popoverTarget"
  [visible]="popoverVisible"
  [showCloseButton]="true"
  [shading]="true"
  width="auto"
  height="auto"
  position="right"
  (onHiding)="onCloseFieldSettings($event)"
>
  <np-advanced-template-fieldsettings
    [excelElement]="popoverElement"
    [mappings]="mappings"
    (onUpdate)="updateNew($event)"
  ></np-advanced-template-fieldsettings>
</dx-popover>
